import { SET_MASTER_DATA, DASHBOARD_SET_COLUMNS,
  GENERIC_DASHBOARD_SET_COLUMNS, GENERIC_DASHBOARD_SET_TRIP_COLUMNS,
  GENERIC_DASHBOARD_SET_CUSTOM_FILTERS, GENERIC_DASHBOARD_SET_CURRENT_CUSTOM_FILTERS,
  GENERIC_DASHBOARD_SET_CUSTOM_ACTIONS, SET_VIEW_TYPE,
  GENERIC_DASHBOARD_SET_CUSTOM_UPDATES, SET_DISPATCH_SCREEN_FOR_HUB,
  GENERIC_DASHBOARD_SET_TASK_COLUMNS, GENERIC_DASHBOARD_PIECE_DETAILS_SET_COLUMNS,
  GENERIC_DASHBOARD_SET_IST_COLUMNS,
  SET_TRIP_FILTER_MASTER,
  SET_TMS_VEHICLE_METADATA,
} from '../actions/constants';
import { getViewFieldConfig } from 'src/components/pages/dashboard/constants';

const defaultState: any = {
  columns_to_show :[],
  full_column_list: [],
  crm_permission:[],
  ops_hub: {
    hub_list: [],
  },
  ltl_masterdata:[],
  ops_filter_list_by_bucket:[],
  ops_current_filter_list_by_bucket:[],
  ops_actions_list_by_bucket: [],
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case SET_MASTER_DATA: {
      return {
        ...state,
        ...action.data,
        ops_current_filter_list_by_bucket: action.data.ops_filter_list_by_bucket,
        //show_enhanced_dispatch_screen: true, // TODO: remove, kept only for dev testing
      };
    }
    case SET_VIEW_TYPE: {
      return {
        ...state,
        viewType: action.data,
      };
    }
    case DASHBOARD_SET_COLUMNS: {
      return{
        ...state,
        columns_to_show:action.data,
      };
    }
    case GENERIC_DASHBOARD_SET_COLUMNS: {
      return{
        ...state,
        ops_consignment_column_list: {
          ...state.ops_consignment_column_list,
          [action.bucket]: action.data,
        },
      };
    }
    case GENERIC_DASHBOARD_PIECE_DETAILS_SET_COLUMNS: {
      return {
        ...state,
        ops_consignment_piece_detail_column_list: action.data,
      };
    }
    case GENERIC_DASHBOARD_SET_TRIP_COLUMNS: {
      return{
        ...state,
        ops_trip_column_list: {
          ...state.ops_trip_column_list,
          [action.bucket]: action.data,
        },
      };
    }
    case GENERIC_DASHBOARD_SET_IST_COLUMNS: {
      return {
        ...state,
        ops_ist_column_list: {
          ...state.ops_ist_column_list,
          [action.bucket]: action.data,
        },
      };
    }
    case GENERIC_DASHBOARD_SET_TASK_COLUMNS: {
      return {
        ...state,
        ops_consolidated_column_list: {
          ...state.ops_consolidated_column_list,
          [action.bucket]: {
            ...state.ops_consolidated_column_list[action.bucket],
            [action.subBucket]: action.data,
          },
        },
      };
    }
    case GENERIC_DASHBOARD_SET_CUSTOM_FILTERS: {
      const fields = getViewFieldConfig(action.viewType);
      const key = fields.filterList;
      return {
        ...state,
        [key]: {
          ...(state as any)[key],
          [action.bucket]: action.data,
        },
      };
    }
    case GENERIC_DASHBOARD_SET_CURRENT_CUSTOM_FILTERS: {
      const fields = getViewFieldConfig(action.viewType);
      const key = fields.currentFilterList;
      return {
        ...state,
        [key]: {
          ...(state as any)[key],
          [action.bucket]: action.data,
        },
      };
    }
    case GENERIC_DASHBOARD_SET_CUSTOM_ACTIONS: {
      return{
        ...state,
        ops_actions_list_by_bucket: {
          ...state.ops_actions_list_by_bucket,
          [action.bucket]: action.data,
        },
      };
    }
    case GENERIC_DASHBOARD_SET_CUSTOM_UPDATES: {
      const obj = {};
      action.buckets.forEach(bucket => {
        obj[bucket] = action.data?.updates;
      });
      return{
        ...state,
        ops_keys_list_by_bucket: {
          ...state.ops_keys_list_by_bucket,
          ...obj,
        },
      };
    }
    case SET_DISPATCH_SCREEN_FOR_HUB: {
      return {
        ...state,
        show_enhanced_dispatch_screen: action.data,
      };
    }

    case SET_TRIP_FILTER_MASTER: {
      return {
        ...state,
        ...action.data,
      };
    }

    case SET_TMS_VEHICLE_METADATA: {
      return {
        ...state,
        ...action.data,
      };
    }

    default: return state;
  }
}
